export enum UtilityTypeEnum {
  ELECTRICITY = 'ELECTRICITY',
  WATER = 'WATER',
  FUEL_OIL = 'FUEL_OIL',
  GAS = 'GAS',
  THERMAL_ENERGY = 'THERMAL_ENERGY',
  STEAM = 'STEAM',
  CONDENSATE = 'CONDENSATE',
  CARBON_DIOXIDE = 'CARBON_DIOXIDE',
  AIR_PRESSURE = 'AIR_PRESSURE',
  TEMPERATURE = 'TEMPERATURE',
  HUMIDITY = 'HUMIDITY',
}

export enum UtilityTypeToUnitEnum {
  ELECTRICITY = 'kWh',
  WATER = 'm³',
  GAS = 'kWh',
  PPM = 'ppm',
  DEGREES_CELSIUS = 'degrees_celsius',
  PERCENTAGE = 'percentage',
  HECTOPASCAL = 'hectopascal',
}
